import Modal from "react-modal";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

// Set the root app element for react-modal
const document = getDocument();
if (document?.querySelector("#root")) {
    Modal.setAppElement("#root");
}
